import { API_ORIGIN } from '../api/axiosClient';

const isExternalUrl = (value) => {
  return /^https?:\/\//i.test(value);
};

const resolveMediaUrl = (url) => {
  if (!url) {
    return null;
  }

  const value = String(url).trim();

  if (!value) {
    return null;
  }

  if (
    value.startsWith('blob:') ||
    value.startsWith('data:')
  ) {
    return value;
  }

  if (value.startsWith('/storage/')) {
    return `${API_ORIGIN}${value}`;
  }

  if (value.startsWith('storage/')) {
    return `${API_ORIGIN}/${value}`;
  }

  if (value.startsWith('/')) {
    return `${API_ORIGIN}${value}`;
  }

  if (isExternalUrl(value)) {
    try {
      const parsedUrl = new URL(value);

      if (
        parsedUrl.hostname === 'localhost' &&
        !parsedUrl.port &&
        parsedUrl.pathname.startsWith('/storage/')
      ) {
        return `${API_ORIGIN}${parsedUrl.pathname}`;
      }

      if (
        parsedUrl.origin === window.location.origin &&
        parsedUrl.pathname.startsWith('/storage/')
      ) {
        return `${API_ORIGIN}${parsedUrl.pathname}`;
      }

      return value;
    } catch {
      return value;
    }
  }

  return `${API_ORIGIN}/storage/${value.replace(/^public\//, '')}`;
};

export default resolveMediaUrl;